import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class DirtRoadTileEntity6 extends TileEntity {
	public static readonly frameName = FrameName.DIRT_ROAD_6;
}

export default DirtRoadTileEntity6;
